/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import DropDown from './drop-down';

export default class TopMenu extends DropDown {
  init() {
    let elmId;
    let self = this;
    this.el.find('li').hover((e) => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      if (elmId !== $(e.currentTarget).attr('id')) {
        if ($(e.target).data('depth') === 0) {
          $(`#${elmId} .js-sub-menu`).hide();
        }
        elmId = $(e.currentTarget).attr('id');
      }
      if (elmId && $(e.target).data('depth') === 0) {
        $(`#${elmId} .js-sub-menu`).show().css({
          top: $(`#${elmId}`).height() + $(`#${elmId}`).position().top
        });
      }
    });
    $('#menu-icon').on('click', function() {
      $('#mobile_top_menu_wrapper').show();
      $('main').toggleClass('menu-open');
      self.toggleMobileMenu();
    });
    $('.js-top-menu').mouseleave(() => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      $(`#${elmId} .js-sub-menu`).hide();
    });
    this.el.on('click', (e) => {
      if (this.el.parent().hasClass('mobile')) {
        return;
      }
      e.stopPropagation();
    });
    prestashop.on('responsive update', function(event) {
      $('.js-sub-menu').removeAttr('style');
      $('main').removeClass('menu-open');
      self.toggleMobileMenu();
    });
    super.init();
  }

  toggleMobileMenu() {
      if ($('main').hasClass('menu-open')){
        // ouverture
        if (satc_headermobilesearchin == '1') $('#mobile_top_menu_wrapper').append($('#search_widget')); // deplace la searchbox dans le menu [mobile]
        
        $("#sa-mask").fadeIn(300,function(){
              $('#notifications').css('display','none');
              $('#wrapper').css('display','none');
              $('#footer').css('display','none');
        });
        window.scrollTo(0, 0);
        //console.log("headermobilesearchin" + satc_headermobilesearchin);
      } else {
        // fermeture
        $('#sa-mask').fadeOut(300);
        $('#notifications').css('display','block');
        $('#wrapper').css('display','block');
        $('#footer').css('display','block');
        if (satc_headermobilesearchin ) $('#search_widget').insertAfter($('#_desktop_logo')); // replace la searchbox dans le header [mobile]
      }
  }

}

/*
    $('#sa-mask')
      .delay(300)
      .queue(function (next) {
        $('#notifications').css('display','none');
        $('#wrapper').css('display','none');
        $('#footer').css('display','none');
        next(); 
    });


$("#sa-mask").fadeOut(300,function(){
        $('#notifications').css('display','none');
        $('#wrapper').css('display','none');
        $('#footer').css('display','none');
});*/


// WEBPACK FOOTER //
// ./js/components/top-menu.js